import z from "zod";

export interface TruckListEntity {
  id: number;
  nombre: string;
  patente: string;
  modulos: string[];
  activo: boolean;
}

export interface TrucksListResponse {
  listado: TruckListEntity[];
  totalPages: number;
  totalRecords: number;
}

export interface TruckDetail {
  id: number;
  nombre: string;
  patente: string;
  modulos: {id :number, descripcion: string}[];
  activo: boolean;
}

export const trucksFilterSchema = z.object({
  nombre: z.any().optional(),
  patente: z.any().optional(),
  tipoModulo: z.any().optional(),
  activo: z.any().optional(),
});

export const truckCreationSchema = z.object({
    nombre: z.any().optional(),
    patente: z.any().optional(),
    modulos: z.any().optional(),
})

export const truckUpdateSchema = z.object({
    nombre: z.any().optional(),
    patente: z.any().optional(),
    modulos: z.any().optional(),
    activo: z.any().optional(),
})


export type TrucksFilterSchema = z.infer<typeof trucksFilterSchema>;
